import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectMedicalAndEvacuationSCTIStep, makeSelectMedicalAndEvacuationSCTIStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';
import { appConfig } from '../../../configureApp';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
  resetFormEuropeanUnionData,
  resetFormMedicalExpenses,
  resetFormDentalExpenses,
  resetFormFunarelExpenses,
  resetFormHospitalised,
  resetFormAccompanyingPersonHospitalised,
  resetFormTheDeathCausedByAnInjury,
  resetFormExpensesArisingFromTerrorism,
  resetFormOpticalTreatment,
  resetFormAncillaryServices,
  resetFormMentalHealth,
  resetFormSexualHealth,
  resetFormExtraTravelAndAccommodation,
  resetFormSearchAndRescue,
  resetFormUrgentCareOutOfHoursvisits,
  resetFormPrescriptions,
  resetFormGPVisits,
  resetFormOtherMedicalExpenses,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import CurrencySelector from '../components/CurrencySelector';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { stepMedicalAndEvacuationLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import FNOLTooltip from '../../../components/FNOLTooltip';
import { AdditionalList } from './components/Additional';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectPolicyTypeCode } from '../../App/selectors';
import { hasAnyMedicalAndEvacuationExpenseItems } from './validation';

export class MedicalAndEvacuationSCTIStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onPrescriptionMedicinesNotInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesNotInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPrescriptionMedicinesForInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesForInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  // Medical & Hospital Expenses
  onMedicalExpenseChange = (data) => {
    this.props.onFormDataChange('form.infoMedicalExpensesItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onMedicalExpenseHospitalisedChange = (data) => {
    this.props.onFormDataChange('form.infoMedicalExpensesHospitalisedItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onMedicalExpenseCompanionChange = (data) => {
    this.props.onFormDataChange('form.infoMedicalExpensesCompanionItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onDentalExpensesChange = (data) => {
    this.props.onFormDataChange('form.infoDentalExpensesItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onFuneralExpensesChange = (data) => {
    this.props.onFormDataChange('form.infoFuneralExpensesItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onExpensesArisingFromTerrorismChange = (data) => {
    this.props.onFormDataChange('form.infoExpensesArisingFromTerrorismItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onOpticalTreatmentChange = (data) => {
    this.props.onFormDataChange('form.infoOpticalTreatmentItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onAncillaryServicesChange = (data) => {
    this.props.onFormDataChange('form.infoAncillaryServicesItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onMentalHealthChange = (data) => {
    this.props.onFormDataChange('form.infoMentalHealthItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSexualHealthChange = (data) => {
    this.props.onFormDataChange('form.infoSexualHealthItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onExtraTravelAndAccommodationChange = (data) => {
    this.props.onFormDataChange('form.infoExtraTravelAndAccommodationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSearchAndRescueChange = (data) => {
    this.props.onFormDataChange('form.infoSearchAndRescueItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onUrgentCareOutOfHoursvisitsChange = (data) => {
    this.props.onFormDataChange('form.infoUrgentCareOutOfHoursVisitsItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPrescriptionsChange = (data) => {
    this.props.onFormDataChange('form.infoPrescriptionsItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onGPVisitsChange = (data) => {
    this.props.onFormDataChange('form.infoGPVisitsItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onRehabilitationAndOccupationalTherapyChange = (data) => {
    this.props.onFormDataChange('form.infoRehabilitationAndOccupationalTherapyItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onMaternityCareChange = (data) => {
    this.props.onFormDataChange('form.infoMaternityCareItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onReplacementStaffChange = (data) => {
    this.props.onFormDataChange('form.infoReplacementStaffItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onRepatriationBenefitChange = (data) => {
    this.props.onFormDataChange('form.infoRepatriationBenefitItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onOtherMedicalExpensesChange = (data) => {
    this.props.onFormDataChange('form.infoOtherMedicalExpensesItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onTheDeathCausedByAnInjuryChange = (data) => {
    this.props.onFormDataChange('form.infoTheDeathCausedByAnInjuryItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const isHasAnyExpenses = hasAnyMedicalAndEvacuationExpenseItems(this.props.form, this.props.policyTypeCode);
    const valid = isHasAnyExpenses && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    if (propertyName === 'form.wereYouHospitalisedForMoreThanThreeDays') {
      this.props.onResetFormHospitalised();
    }
    if (propertyName === 'form.wereYouHospitalisedForMoreThanTenDays') {
      this.props.onResetFormHospitalised();
    }
    if (propertyName === 'form.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised') {
      this.props.onResetFormAccompanyingPersonHospitalised();
    }
    if (propertyName === 'form.wasTheDeathCausedByAnInjury') {
      this.props.onResetFormTheDeathCausedByAnInjury();
    }
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    const isHasAnyExpenses = hasAnyMedicalAndEvacuationExpenseItems(this.props.form, this.props.policyTypeCode);
    // const errors = this.validatorGroup.getErrors();
    const valid = isHasAnyExpenses && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  handleExpensesSelected = (propertyName) => (event) => {
    const { whatExpensesAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      if (name === 'Medical & Hospital Expenses') {
        this.props.onResetFormMedicalExpenses();
      }
      if (name === 'Dental Expenses') {
        this.props.onResetFormDentalExpenses();
      }
      if (name === 'Funeral Expenses') {
        this.props.onResetFormFunarelExpenses();
      }
      if (name === 'Expenses arising from terrorism') {
        this.props.onResetFormExpensesArisingFromTerrorism();
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleMedicalHospitalExpensesSelected = (propertyName) => (event) => {
    const { whatAreYourExpensesRelatedTo } = this.props.form;
    const expensesSelected = !!whatAreYourExpensesRelatedTo && typeof whatAreYourExpensesRelatedTo.toJS === 'function'
      ? whatAreYourExpensesRelatedTo.toJS()
      : whatAreYourExpensesRelatedTo || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      switch (name) {
        case 'Optical treatment':
          this.props.onResetFormOpticalTreatment();
          break;
        case 'Ancillary services':
          this.props.onResetFormAncillaryServices();
          break;
        case 'Mental Health':
          this.props.onResetFormMentalHealth();
          break;
        case 'Sexual Health':
          this.props.onResetFormSexualHealth();
          break;
        case 'Extra travel and accommodation':
          this.props.onResetFormExtraTravelAndAccommodation();
          break;
        case 'Search and rescue':
          this.props.onResetFormSearchAndRescue();
          break;
        case 'Urgent care / out of hours visits':
          this.props.onResetFormUrgentCareOutOfHoursvisits();
          break;
        case 'Prescriptions':
          this.props.onResetFormPrescriptions();
          break;
        case 'GP visits':
          this.props.onResetFormGPVisits();
          break;
        case 'Other medical expenses':
          this.props.onResetFormOtherMedicalExpenses();
          break;
        default:
          break;
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  // Medical & Hospital Expenses
  renderOpticalTreatmentItems() {
    const { infoOpticalTreatmentItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoOpticalTreatmentItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onOpticalTreatmentChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderAncillaryServicesItems() {
    const { infoAncillaryServicesItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoAncillaryServicesItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onAncillaryServicesChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderMentalHealthItems() {
    const { infoMentalHealthItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoMentalHealthItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onMentalHealthChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderSexualHealthItems() {
    const { infoSexualHealthItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoSexualHealthItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onSexualHealthChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderExtraTravelAndAccommodationItems() {
    const { infoExtraTravelAndAccommodationItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoExtraTravelAndAccommodationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onExtraTravelAndAccommodationChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderSearchAndRescueItems() {
    const { infoSearchAndRescueItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoSearchAndRescueItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onSearchAndRescueChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderUrgentCareOutOfHoursvisitsItems() {
    const { infoUrgentCareOutOfHoursVisitsItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoUrgentCareOutOfHoursVisitsItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onUrgentCareOutOfHoursvisitsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderPrescriptionsItems() {
    const { infoPrescriptionsItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoPrescriptionsItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onPrescriptionsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderGPVisitsItems() {
    const { infoGPVisitsItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoGPVisitsItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onGPVisitsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderRehabilitationAndOccupationalTherapyItems() {
    const { infoRehabilitationAndOccupationalTherapyItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoRehabilitationAndOccupationalTherapyItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onRehabilitationAndOccupationalTherapyChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }


  renderMaternityCareItems() {
    const { infoMaternityCareItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoMaternityCareItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onMaternityCareChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }


  renderReplacementStaffItems() {
    const { infoReplacementStaffItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoReplacementStaffItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onReplacementStaffChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderRepatriationBenefitItems() {
    const { infoRepatriationBenefitItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoRepatriationBenefitItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onRepatriationBenefitChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderOtherMedicalExpensesItems() {
    const { infoOtherMedicalExpensesItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoOtherMedicalExpensesItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onOtherMedicalExpensesChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderMedicalExpenseItems() {
    const { infoMedicalExpensesItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoMedicalExpensesItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onMedicalExpenseChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderMedicalExpenseHospitalisedItems() {
    const { infoMedicalExpensesHospitalisedItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoMedicalExpensesHospitalisedItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onMedicalExpenseHospitalisedChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderMedicalExpenseCompanionItems() {
    const { infoMedicalExpensesCompanionItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoMedicalExpensesCompanionItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onMedicalExpenseCompanionChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderDentalExpensesItems() {
    const { infoDentalExpensesItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoDentalExpensesItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onDentalExpensesChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderFuneralExpensesItems() {
    const { infoFuneralExpensesItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoFuneralExpensesItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onFuneralExpensesChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderExpensesArisingFromTerrorismItems() {
    const { infoExpensesArisingFromTerrorismItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoExpensesArisingFromTerrorismItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onExpensesArisingFromTerrorismChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderTheDeathCausedByAnInjuryItems() {
    const { infoTheDeathCausedByAnInjuryItems } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoTheDeathCausedByAnInjuryItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onTheDeathCausedByAnInjuryChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderMedicalExpenses() {
    const {
      whatAreYourExpensesRelatedTo,
      wereYouHospitalisedForMoreThanThreeDays,
      wereYouHospitalisedForMoreThanTenDays,
      admissionDate,
      dischargeDate,
      didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const expensesSelected = !!whatAreYourExpensesRelatedTo && typeof whatAreYourExpensesRelatedTo.toJS === 'function'
      ? whatAreYourExpensesRelatedTo.toJS()
      : whatAreYourExpensesRelatedTo || [];
    const { isSummary, submitted, policyTypeCode } = this.props;
    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    const policyTypeVisitingNZ = ['VISIT-NZ', 'VISIT-NZ-WLP001'];
    const isVisitingNewZealand = policyTypeVisitingNZ.includes(policyTypeCode);
    const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
    const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);
    const isShowSubBenefits = isInternationalStudent || isVisitingNewZealand || isWorkingOverseas;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        {!isShowSubBenefits && (
          <div>
            {this.renderMedicalExpenseItems()}
            <div>
              <div className={'row'}>
                <div className={'col-sm-12 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.wereYouHospitalisedForMoreThanThreeDays} />
                  </PageSectionHeader>
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="true"
                        checked={wereYouHospitalisedForMoreThanThreeDays === 'true'}
                        onChange={this.handleChange('form.wereYouHospitalisedForMoreThanThreeDays')}
                      />
                      <FormattedMessage {...messages.yes} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="false"
                        checked={wereYouHospitalisedForMoreThanThreeDays === 'false'}
                        onChange={this.handleChange('form.wereYouHospitalisedForMoreThanThreeDays')}
                      />
                      <FormattedMessage {...messages.no} />
                    </OptionsContainer>
                  </FlexBox>
                </div>
              </div>
              {wereYouHospitalisedForMoreThanThreeDays === 'true' &&
                (
                  <div className={'ml-2 row'}>
                    <div className={'col-sm-12 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.periodOfHospitalisation} />
                      </PageSectionHeader>
                    </div>
                    <div className={'col-sm-4 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.admissionDate} />
                      </PageSectionHeader>
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="admissionDate"
                        type="text"
                        onDayChange={this.handleDayChange('form.admissionDate')}
                        value={admissionDate}
                      />
                    </div>
                    <div className={'col-sm-4 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.dischargeDate} />
                      </PageSectionHeader>
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="dischargeDate"
                        type="text"
                        onDayChange={this.handleDayChange('form.dischargeDate')}
                        value={dischargeDate}
                      />
                    </div>
                    <div className={'col-sm-4 form-group'}>
                    </div>
                  </div>
                )
              }
              {wereYouHospitalisedForMoreThanThreeDays === 'true' &&
                <div className={'ml-2 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.cashAllowanceWhileInHospital} />
                    </PageSectionHeader>
                    {this.renderMedicalExpenseHospitalisedItems()}
                  </div>
                </div>
              }
              {(wereYouHospitalisedForMoreThanThreeDays === 'true') &&
                <div className={'ml-2 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised} />
                    </PageSectionHeader>
                    <FlexBox>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="true"
                          checked={didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true'}
                          onChange={this.handleChange('form.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised')}
                        />
                        <FormattedMessage {...messages.yes} />
                      </OptionsContainer>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="false"
                          checked={didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'false'}
                          onChange={this.handleChange('form.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised')}
                        />
                        <FormattedMessage {...messages.no} />
                      </OptionsContainer>
                    </FlexBox>
                  </div>
                </div>
              }
            </div>
            {didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true' &&
              <div className={'ml-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.accompanyingPersonExpenses} />
                </PageSectionHeader>
                {this.renderMedicalExpenseCompanionItems()}
              </div>
            }
          </div>
        )}
        {isShowSubBenefits && (
          <div className={'row'}>
            <div className={'pt-2 col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.whatAreYourExpensesRelatedTo} />
              </PageSectionHeader>
            </div>
            <div className={'col-sm-12 form-group'}>
              {(isInternationalStudent || isWorkingOverseas) && (<div className="col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Optical treatment"
                  checked={expensesSelected.includes('Optical treatment')}
                  onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                />
                <span>
                  <FormattedMessage {...messages.opticalTreatment} />
                </span>
                {expensesSelected.includes('Optical treatment') && (
                  <div className="col-sm-12 form-group">
                    {this.renderOpticalTreatmentItems()}
                  </div>
                )}
              </div>)}
              {isShowSubBenefits && (
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Ancillary services"
                    checked={expensesSelected.includes('Ancillary services')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.ancillaryServices} /> <FNOLTooltip dataFor={'policyNumberHint'} content={messages.ancillaryServicestTooltip.defaultMessage} />
                  </span>
                  {expensesSelected.includes('Ancillary services') && (
                    <span>
                      <div className={'col-sm-12 form-group'}>
                        {this.renderAncillaryServicesItems()}
                      </div>
                    </span>
                  )}
                </div>
              )}
              {/* Rehabilitation and occupational therapy */}
              {isWorkingOverseas && (
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Rehabilitation and occupational therapy"
                    checked={expensesSelected.includes('Rehabilitation and occupational therapy')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.rehabilitationAndOccupationalTherapy} /> <FNOLTooltip place={'bottom'} dataFor={'policyNumberHint'} content={messages.rehabilitationAndOccupationalTherapyTooltip.defaultMessage} />
                  </span>
                  {expensesSelected.includes('Rehabilitation and occupational therapy') && (
                    <span>
                      <div className={'col-sm-12 form-group'}>
                        {this.renderRehabilitationAndOccupationalTherapyItems()}
                      </div>
                    </span>
                  )}
                </div>
              )}
              {/* Maternity care */}
              {isWorkingOverseas && (
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Maternity care"
                    checked={expensesSelected.includes('Maternity care')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.maternityCare} />
                  </span>
                  {expensesSelected.includes('Maternity care') && (
                    <span>
                      <div className={'col-sm-12 form-group'}>
                        {this.renderMaternityCareItems()}
                      </div>
                    </span>
                  )}
                </div>
              )}
              {(isInternationalStudent || isWorkingOverseas) && (
                <div className="col-sm-12 form-group">
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Mental Health"
                    checked={expensesSelected.includes('Mental Health')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.mentalHealth} />
                  </span>
                  {expensesSelected.includes('Mental Health') && (
                    <div className="col-sm-12 form-group">
                      {this.renderMentalHealthItems()}
                    </div>
                  )}
                </div>
              )}
              {isInternationalStudent && (
                <div className="col-sm-12 form-group">
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Sexual Health"
                    checked={expensesSelected.includes('Sexual Health')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.sexualHealth} />
                  </span>
                  {expensesSelected.includes('Sexual Health') && (
                    <div className="col-sm-12 form-group">
                      {this.renderSexualHealthItems()}
                    </div>
                  )}
                </div>
              )}
              {isShowSubBenefits && (
                <div className="col-sm-12 form-group">
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Extra travel and accommodation"
                    checked={expensesSelected.includes('Extra travel and accommodation')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.extraTravelAndAccommodation} />
                  </span>
                  {expensesSelected.includes('Extra travel and accommodation') && (
                    <div className="col-sm-12 form-group">
                      {this.renderExtraTravelAndAccommodationItems()}
                    </div>
                  )}
                </div>
              )}
              {/* Replacement staff */}
              {isWorkingOverseas && (
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Replacement staff"
                    checked={expensesSelected.includes('Replacement staff')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.replacementStaff} />
                  </span>
                  {expensesSelected.includes('Replacement staff') && (
                    <span>
                      <div className={'col-sm-12 form-group'}>
                        {this.renderReplacementStaffItems()}
                      </div>
                    </span>
                  )}
                </div>
              )}
              {/* Repatriation benefit */}
              {isWorkingOverseas && (
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Repatriation benefit"
                    checked={expensesSelected.includes('Repatriation benefit')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.repatriationBenefit} />
                  </span>
                  {expensesSelected.includes('Repatriation benefit') && (
                    <span>
                      <div className={'col-sm-12 form-group'}>
                        {this.renderRepatriationBenefitItems()}
                      </div>
                    </span>
                  )}
                </div>
              )}
              {(isInternationalStudent || isVisitingNewZealand) && (
                <div className="col-sm-12 form-group">
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Search and rescue"
                    checked={expensesSelected.includes('Search and rescue')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.searchAndRescue} />
                  </span>
                  {expensesSelected.includes('Search and rescue') && (
                    <div className="col-sm-12 form-group">
                      {this.renderSearchAndRescueItems()}
                    </div>
                  )}
                </div>
              )}
              {isInternationalStudent && (
                <div className="col-sm-12 form-group">
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Urgent care / out of hours visits"
                    checked={expensesSelected.includes('Urgent care / out of hours visits')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.urgentCareOutOfHoursvisits} />
                  </span>
                  {expensesSelected.includes('Urgent care / out of hours visits') && (
                    <div className="col-sm-12 form-group">
                      {this.renderUrgentCareOutOfHoursvisitsItems()}
                    </div>
                  )}
                </div>
              )}
              {isInternationalStudent && (
                <div className="col-sm-12 form-group">
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="Prescriptions"
                    checked={expensesSelected.includes('Prescriptions')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.prescriptions} />
                  </span>
                  {expensesSelected.includes('Prescriptions') && (
                    <div className="col-sm-12 form-group">
                      {this.renderPrescriptionsItems()}
                    </div>
                  )}
                </div>
              )}
              {isInternationalStudent && (
                <div className="col-sm-12 form-group">
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="GP visits"
                    checked={expensesSelected.includes('GP visits')}
                    onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                  />
                  <span>
                    <FormattedMessage {...messages.GPVisits} />
                  </span>
                  {expensesSelected.includes('GP visits') && (
                    <div className="col-sm-12 form-group">
                      {this.renderGPVisitsItems()}
                    </div>
                  )}
                </div>
              )}
              <div className="col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Other medical expenses"
                  checked={expensesSelected.includes('Other medical expenses')}
                  onChange={this.handleMedicalHospitalExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                />
                <span>
                  <FormattedMessage {...messages.otherMedicalExpenses} />
                </span>
                {expensesSelected.includes('Other medical expenses') && (
                  <div className="col-sm-12 form-group">
                    {this.renderOtherMedicalExpensesItems()}
                    {isVisitingNewZealand && (
                      <div>
                        <div className={'row'}>
                          <div className={'col-sm-12 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.wereYouHospitalisedForMoreThanTenDays} />
                            </PageSectionHeader>
                            <FlexBox>
                              <OptionsContainer>
                                <input
                                  disabled={isReadOnly}
                                  type="radio"
                                  value="true"
                                  checked={wereYouHospitalisedForMoreThanTenDays === 'true'}
                                  onChange={this.handleChange('form.wereYouHospitalisedForMoreThanTenDays')}
                                />
                                <FormattedMessage {...messages.yes} />
                              </OptionsContainer>
                              <OptionsContainer>
                                <input
                                  disabled={isReadOnly}
                                  type="radio"
                                  value="false"
                                  checked={wereYouHospitalisedForMoreThanTenDays === 'false'}
                                  onChange={this.handleChange('form.wereYouHospitalisedForMoreThanTenDays')}
                                />
                                <FormattedMessage {...messages.no} />
                              </OptionsContainer>
                            </FlexBox>
                          </div>
                        </div>
                        {wereYouHospitalisedForMoreThanTenDays === 'true' && (
                          <div className={'ml-2 row'}>
                            <div className={'col-sm-12 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised} />
                              </PageSectionHeader>
                              <FlexBox>
                                <OptionsContainer>
                                  <input
                                    disabled={isReadOnly}
                                    type="radio"
                                    value="true"
                                    checked={didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true'}
                                    onChange={this.handleChange('form.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised')}
                                  />
                                  <FormattedMessage {...messages.yes} />
                                </OptionsContainer>
                                <OptionsContainer>
                                  <input
                                    disabled={isReadOnly}
                                    type="radio"
                                    value="false"
                                    checked={didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'false'}
                                    onChange={this.handleChange('form.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised')}
                                  />
                                  <FormattedMessage {...messages.no} />
                                </OptionsContainer>
                              </FlexBox>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    {!isVisitingNewZealand && (
                      <div>
                        <div className={'row'}>
                          <div className={'col-sm-12 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.wereYouHospitalisedForMoreThanThreeDays} />
                            </PageSectionHeader>
                            <FlexBox>
                              <OptionsContainer>
                                <input
                                  disabled={isReadOnly}
                                  type="radio"
                                  value="true"
                                  checked={wereYouHospitalisedForMoreThanThreeDays === 'true'}
                                  onChange={this.handleChange('form.wereYouHospitalisedForMoreThanThreeDays')}
                                />
                                <FormattedMessage {...messages.yes} />
                              </OptionsContainer>
                              <OptionsContainer>
                                <input
                                  disabled={isReadOnly}
                                  type="radio"
                                  value="false"
                                  checked={wereYouHospitalisedForMoreThanThreeDays === 'false'}
                                  onChange={this.handleChange('form.wereYouHospitalisedForMoreThanThreeDays')}
                                />
                                <FormattedMessage {...messages.no} />
                              </OptionsContainer>
                            </FlexBox>
                          </div>
                        </div>
                        {wereYouHospitalisedForMoreThanThreeDays === 'true' &&
                          (
                            <div className={'ml-2 row'}>
                              <div className={'col-sm-12 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.periodOfHospitalisation} />
                                </PageSectionHeader>
                              </div>
                              <div className={'col-sm-4 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.admissionDate} />
                                </PageSectionHeader>
                                <DatePicker
                                  position={'bottom-start'}
                                  disabled={isReadOnly}
                                  name="admissionDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.admissionDate')}
                                  value={admissionDate}
                                />
                              </div>
                              <div className={'col-sm-4 form-group'}>
                                <PageSectionHeader>
                                  <FormattedMessage {...messages.dischargeDate} />
                                </PageSectionHeader>
                                <DatePicker
                                  position={'bottom-start'}
                                  disabled={isReadOnly}
                                  name="dischargeDate"
                                  type="text"
                                  onDayChange={this.handleDayChange('form.dischargeDate')}
                                  value={dischargeDate}
                                />
                              </div>
                              <div className={'col-sm-4 form-group'}>
                              </div>
                            </div>
                          )
                        }
                        {wereYouHospitalisedForMoreThanThreeDays === 'true' &&
                          <div className={'ml-2 row'}>
                            <div className={'col-sm-12 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.cashAllowanceWhileInHospital} />
                              </PageSectionHeader>
                              {this.renderMedicalExpenseHospitalisedItems()}
                            </div>
                          </div>
                        }
                        {(wereYouHospitalisedForMoreThanThreeDays === 'true') &&
                          <div className={'ml-2 row'}>
                            <div className={'col-sm-12 form-group'}>
                              <PageSectionHeader>
                                <FormattedMessage {...messages.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised} />
                              </PageSectionHeader>
                              <FlexBox>
                                <OptionsContainer>
                                  <input
                                    disabled={isReadOnly}
                                    type="radio"
                                    value="true"
                                    checked={didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true'}
                                    onChange={this.handleChange('form.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised')}
                                  />
                                  <FormattedMessage {...messages.yes} />
                                </OptionsContainer>
                                <OptionsContainer>
                                  <input
                                    disabled={isReadOnly}
                                    type="radio"
                                    value="false"
                                    checked={didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'false'}
                                    onChange={this.handleChange('form.didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised')}
                                  />
                                  <FormattedMessage {...messages.no} />
                                </OptionsContainer>
                              </FlexBox>
                            </div>
                          </div>
                        }
                      </div>
                    )}
                    {didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true' &&
                      <div className={'ml-3'}>
                        <PageSectionHeader>
                          <FormattedMessage {...messages.accompanyingPersonExpenses} />
                        </PageSectionHeader>
                        {this.renderMedicalExpenseCompanionItems()}
                      </div>
                    }
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderDentalExpenses() {
    return (
      <div>
        {this.renderDentalExpensesItems()}
      </div>
    );
  }

  renderFuneralExpenses() {
    const {
      wasTheDeathCausedByAnInjury,
    } = this.props.form;
    const { isSummary, submitted, policyTypeCode } = this.props;
    const isInternationalMedical = ['INT-MED-NZ', 'INT-MED-AU'].includes(policyTypeCode);
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        {this.renderFuneralExpensesItems()}
        {isInternationalMedical &&
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wasTheDeathCausedByAnInjury} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasTheDeathCausedByAnInjury === 'true'}
                    onChange={this.handleChange('form.wasTheDeathCausedByAnInjury')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasTheDeathCausedByAnInjury === 'false'}
                    onChange={this.handleChange('form.wasTheDeathCausedByAnInjury')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {wasTheDeathCausedByAnInjury === 'true' &&
          <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.lossOfLife} />
              </PageSectionHeader>
            </div>
            <div className={'col-sm-12 form-group'}>
              {this.renderTheDeathCausedByAnInjuryItems()}
            </div>
          </div>
        }
      </div>
    );
  }

  renderExpensesArisingFromTerrorism() {
    return (
      <div>
        {this.renderExpensesArisingFromTerrorismItems()}
      </div>
    );
  }

  render() {
    const {
      whatExpensesAreYouClaimingFor,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    return (
      <div className="app-content">
        <div>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.thisSectionRelatedToMedicalExpenses} />
            </PageSectionHeader>
          </div>
          <div className={'col-sm-12 form-group'}>
            <Validate
              name="whatExpensesAreYouClaimingFor"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={expensesSelected}
              fieldName={messages.whatExpensesAreYouClaimingFor}
            >
              <div className={'pt-2 col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Medical & Hospital Expenses"
                  checked={expensesSelected.includes('Medical & Hospital Expenses')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.medicalHospitalExpenses} />
                </span>
                {expensesSelected.includes('Medical & Hospital Expenses') && (
                  <div className={'ml-1 row'}>
                    <div className="col-sm-12 form-group">
                      {this.renderMedicalExpenses()}
                    </div>
                  </div>
                )}
              </div>
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Dental Expenses"
                  checked={expensesSelected.includes('Dental Expenses')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.dentalExpenses} />
                </span>
                {expensesSelected.includes('Dental Expenses') && (
                  <span>
                    <div className={'col-sm-12 form-group'}>
                      {this.renderDentalExpenses()}
                    </div>
                  </span>
                )}
              </div>
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Funeral Expenses"
                  checked={expensesSelected.includes('Funeral Expenses')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.funeralExpenses} />
                </span>
                {expensesSelected.includes('Funeral Expenses') && (
                  <span>
                    <div className={'col-sm-12 form-group'}>
                      {this.renderFuneralExpenses()}
                    </div>
                  </span>
                )}
              </div>
              <div className={'col-sm-12 form-group'}>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Expenses arising from terrorism"
                  checked={expensesSelected.includes('Expenses arising from terrorism')}
                  onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.expensesArisingFromTerrorism} />
                </span>
                {expensesSelected.includes('Expenses arising from terrorism') && (
                  <span>
                    <div className={'col-sm-12 form-group'}>
                      {this.renderExpensesArisingFromTerrorism()}
                    </div>
                  </span>
                )}
              </div>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.whatExpensesAreYouClaimingFor}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className={`${appConfig.reactAppEnv === 'scti' ? 'base-button back-button' : 'btn-outline'}`}
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

MedicalAndEvacuationSCTIStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  onResetFormData: PropTypes.func,
  onResetFormEuropeanUnionData: PropTypes.func,
  onResetFormMedicalExpenses: PropTypes.func,
  onResetFormDentalExpenses: PropTypes.func,
  onResetFormFunarelExpenses: PropTypes.func,
  onResetFormHospitalised: PropTypes.func,
  onResetFormAccompanyingPersonHospitalised: PropTypes.func,
  onResetFormTheDeathCausedByAnInjury: PropTypes.func,
  onResetFormExpensesArisingFromTerrorism: PropTypes.func,
  onResetFormOpticalTreatment: PropTypes.func,
  onResetFormAncillaryServices: PropTypes.func,
  onResetFormMentalHealth: PropTypes.func,
  onResetFormSexualHealth: PropTypes.func,
  onResetFormExtraTravelAndAccommodation: PropTypes.func,
  onResetFormSearchAndRescue: PropTypes.func,
  onResetFormUrgentCareOutOfHoursvisits: PropTypes.func,
  onResetFormPrescriptions: PropTypes.func,
  onResetFormGPVisits: PropTypes.func,
  onResetFormOtherMedicalExpenses: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  policyTypeCode: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectMedicalAndEvacuationSCTIStep(),
  errors: makeSelectMedicalAndEvacuationSCTIStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  policyTypeCode: makeSelectPolicyTypeCode(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  onResetFormEuropeanUnionData: () => dispatch(resetFormEuropeanUnionData()),
  onResetFormMedicalExpenses: () => dispatch(resetFormMedicalExpenses()),
  onResetFormDentalExpenses: () => dispatch(resetFormDentalExpenses()),
  onResetFormFunarelExpenses: () => dispatch(resetFormFunarelExpenses()),
  onResetFormHospitalised: () => dispatch(resetFormHospitalised()),
  onResetFormAccompanyingPersonHospitalised: () => dispatch(resetFormAccompanyingPersonHospitalised()),
  onResetFormTheDeathCausedByAnInjury: () => dispatch(resetFormTheDeathCausedByAnInjury()),
  onResetFormExpensesArisingFromTerrorism: () => dispatch(resetFormExpensesArisingFromTerrorism()),
  onResetFormOpticalTreatment: () => dispatch(resetFormOpticalTreatment()),
  onResetFormAncillaryServices: () => dispatch(resetFormAncillaryServices()),
  onResetFormMentalHealth: () => dispatch(resetFormMentalHealth()),
  onResetFormSexualHealth: () => dispatch(resetFormSexualHealth()),
  onResetFormExtraTravelAndAccommodation: () => dispatch(resetFormExtraTravelAndAccommodation()),
  onResetFormSearchAndRescue: () => dispatch(resetFormSearchAndRescue()),
  onResetFormUrgentCareOutOfHoursvisits: () => dispatch(resetFormUrgentCareOutOfHoursvisits()),
  onResetFormPrescriptions: () => dispatch(resetFormPrescriptions()),
  onResetFormGPVisits: () => dispatch(resetFormGPVisits()),
  onResetFormOtherMedicalExpenses: () => dispatch(resetFormOtherMedicalExpenses()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'medicalAndEvacuationSCTIStep', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(MedicalAndEvacuationSCTIStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/index.js